import { Colors } from '../../consts/Colors';

export default class Zone4 extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.zoneX, zoneData.zoneY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneData = zoneData;
        this.zoneId = zoneData.zoneId;
        this.zoneType = zoneData.zoneType;

        this.cardDropped = undefined;
        this.isDone = false;

        // this.dropZone = this.scene.add.image(0, 0, zoneData.image).setOrigin(0.5);
        this.dropZone = this.scene.add.rexRoundRectangle(0, 0, 350, 40, 8, Colors.Elmt.White).setOrigin(0.5);
        this.add(this.dropZone);
        this.setActive()
        // this.annimation()

    }
    setActive() {
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    onPointerOver() {
        this.dropZone.setFillStyle(Colors.Elmt.LightGrey);
    }
    onPointerOut() {
        this.dropZone.setFillStyle(0xFFFFFF);

    }
    dragOnPointerOver() {
        this.dropZone.setFillStyle(Colors.Elmt.LightGrey);
    }
    dragOnPointerOut() {
        this.dropZone.setFillStyle(0xFFFFFF);

    }
    onDrop(cardDropped) {
        let previousCard = undefined
        if (this.cardDropped !== undefined) {
            this.cardDropped.reset()
            previousCard = this.cardDropped
        }

        this.cardDropped = cardDropped
        cardDropped.x = this.x - cardDropped.parentContainer.x
        cardDropped.y = this.y - cardDropped.parentContainer.y

        this.dropZone.setFillStyle(0xFFFFFF);
        this.isDone = true;

        return previousCard
    }

    reset() {
        this.setActive()
        this.isDone = false;
        this.cardDropped = undefined
    }

    bounceAnimation(delay){
        this.scene.tweens.add({
            targets: this.dropZone,
            scale: 1.2,
            duration: 200,
            delay: delay,
            yoyo: true,
        });
    }

}